import type { MultiLang } from '../config';
import IndexTree from '../database/blocks/IndexTree';
import Search from '../database/blocks/Search';
import Functions from '../functions';
import MainMenu from './blocks/MainMenu';

interface Props {
    lang: MultiLang;
}

const LeftColumn = (props: Props) => {
    const { lang } = props;
    return (
        <div className="leftcolumn">
            <div className="block">
                <h2 className="blockTitle">{Functions.mlang('[en]Main Menu[/en][ja]メインメニュー[/ja]', lang)}</h2>
                <div className="blockContent">
                    <MainMenu lang={lang} />
                </div>
            </div>
            <div className="block">
                <h2 className="blockTitle">
                    {Functions.mlang('[en]Index Tree[/en][ja]インデックスツリー[/ja]', lang)}
                </h2>
                <div className="blockContent">
                    <IndexTree lang={lang} />
                </div>
            </div>
            <div className="block">
                <h2 className="blockTitle">{Functions.mlang('[en]Search[/en][ja]検索[/ja]', lang)}</h2>
                <div className="blockContent">
                    <Search lang={lang} />
                </div>
            </div>
        </div>
    );
};

export default LeftColumn;
